import { Product, useGetProductQuery } from 'integration/resources/products'

export const useProductEditScreen = (idOrSlug: string) => {
  const product = useGetProductQuery(idOrSlug)

  return { product: product.data?.data as Product }
}
